import React, { useEffect,useState } from "react";
import axios from "axios";
import './Order.css'; // File untuk styling
import { useLocation, useNavigate } from "react-router-dom";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
  } from "@mui/material";
import LoadingScreen from "../../component/LoadingScreen";

function OrderApproval() {
    const [orderDetail, setOrderDetail] = useState({ orderItemlistByOrderId: [] ,  orderFeedbackListByOrderId: [], orderApprovalListByOrderId: []});
    const [selectedType, setSelectedType] = useState('');
    const [selectedPriority, setSelectedPriority] = useState('');
    const [customerByToken, setCustomerByToken] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const resource = "order-approval";
    const storedToken = localStorage.getItem("token");
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  authorization: 'Basic eGNwOk50dGkyMDI0IQ=='
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();
      }, []);

    useEffect(() => {
        // Retrieve the token from local storage  
        const storedToken = localStorage.getItem('token');
        if (storedToken) {   
            loadUserByToken(storedToken);
          }
    }, []);

    useEffect(() => {
        typeSelected(orderDetail.order_type);
    }, [orderDetail]);

    useEffect(() => {
        prioritySelected(orderDetail.order_priority);
    }, [orderDetail]);

    useEffect(() => {
        loadOrderDetail(searchParams.get('param1'));
      },  []);

    const loadUserByToken = async (token) => {
        const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${token}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
        setCustomerByToken(result.data[0])
    }

    function typeSelected(orderType) {
        if (orderType === 'Interconnection to Other Tenant Device') {
            setSelectedType('type-one');
        } else if (orderType === 'Interconnection to Your Own Device') {
            setSelectedType('type-two');
        }
    }

    function prioritySelected(orderPriority) {
        if (orderPriority === 'Normal') {
            setSelectedPriority('priority-one');
        } else if (orderPriority === 'High') {
            setSelectedPriority('priority-two');
        } 
    }

    const loadOrderDetail = async (xcpOrderId) => {
        try {       
        const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-detail?param1=${xcpOrderId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
        const data = result.data;
        setOrderDetail(data);
        } catch (error) {
        console.error("Error loading order list:", error);
        }
    };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}/${month}/${year}`;
      };

      function getCurrenDate() {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        
        let currentDate = `${day}/${month}/${year}`;
        return currentDate
      }
      
      function getCurrenDateForDb() {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        let currentDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        return currentDate
      }
      
      //post order Approval
    const [notes, setNotes] = useState('');
    const [orderStatusCode, setOrderStatusCode] = useState('');
    const [error, setError] = useState('');
    const [openConfirmApprove, setOpenConfirmApprove] = useState(false);
    const [openConfirmReject, setOpenConfirmReject] = useState(false);

    const handleSubmit = async (event) => {
        setIsLoading(true);
        const userName = customerByToken.email
        const orderId = orderDetail.order_id
        const currentDate = getCurrenDateForDb();
        try {
            const response = await fetch('https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-approval', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: 'Basic eGNwOk50dGkyMDI0IQ=='
                },
                body: JSON.stringify({
                    userName: userName,
                    orderId: orderId,
                    notes: notes,
                    orderStatusCode: orderStatusCode,
                    approvalDate: currentDate,
                }),
            });

            const data = await response.json();
            const responseBody = JSON.parse(data.body);

            const statusCode = data.statusCode;
            setIsLoading(false);
            
            if (!response.ok) {
                setError(responseBody.message || 'Network response was not ok.');
                throw new Error('Network response was not ok.');
            }
    
            if (statusCode != 200){
                setError(responseBody.message || 'Network response was not ok.');
            }else{
                setError("");
                // Navigate to the target page
                navigate('/order-list');
            }           

            // Handle server response (e.g., redirect to another page or show a success message)
        } catch (error) {
            console.error('Fetch Error:', error.message);
            // Handle fetch error (e.g., show an error message to the user)
        } 
    }

    const handleClose = () => {
        setOpenConfirmApprove(false);
        setOpenConfirmReject(false);
      };

      const handleConfirmation = async (event) => {
        event.preventDefault();
        if(orderStatusCode === "XCPSTS-002"){
            setOpenConfirmApprove(true);
        }else if(orderStatusCode ==="XCPSTS-100"){
            setOpenConfirmReject(true);
        }
      };

    return (
        <div className='container-order-input'>    
        {isLoading && <LoadingScreen />}  
            <Dialog open={openConfirmApprove}>
                    <DialogTitle>{"Are you sure you want to approve this order?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Clicking "Yes" will approve this order.
                            </DialogContentText>
                        </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={handleSubmit} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>   
                <Dialog open={openConfirmReject}>
                    <DialogTitle>{"Are you sure you want to reject this order?"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Clicking "Yes" will reject this order.
                            </DialogContentText>
                        </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                        <Button onClick={handleSubmit} color="primary" autoFocus>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog> 
            <h1 className='main-title'>Cross Connect Order Approval</h1> 
            <div className="order-information-order-input">
                <div className='title-order-input'>                            
                    <h5>Order Information</h5>  
                </div>                      
                <div className="radio-button">
                        <label>Cross Connect Type</label>
                        <div className="radio-button-option">
                            <input type="radio" name="connect" id="connect-one" checked={selectedType === 'type-one'} disabled/>
                            <label htmlFor="connect-one">Interconnection to other tenant device</label>
                        </div>
                        <div className="radio-button-option">
                            <input type="radio" name="connect" id="connect-two" checked={selectedType === 'type-two'} disabled/>
                            <label htmlFor="connect-two">Interconnection to your own device</label>
                        </div>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="comboBox">Destination</label>
                        <select id="comboBox" name="options" disabled>
                            <option value="option1">{orderDetail.company_destination}</option>
                        </select>                   
                    </div>
                    <div className="radio-button">
                        <label>Order Priority</label>
                        <div className="radio-button-option">
                            <input type="radio" name="orderPriority" id="order-priority-one" checked={selectedPriority === 'priority-one'} disabled/>
                            <label htmlFor="order-priority-one">Normal</label>
                        </div>
                        <div className="radio-button-option">
                            <input type="radio" name="orderPriority" id="order-priority-two" checked={selectedPriority === 'priority-two'} disabled/>
                            <label htmlFor="order-priority-two">High</label>
                        </div>
                    </div>
            </div>

            <div className='box-two-part'>           
                <div className="requestor-information">
                    <div className="title-box-order-input">
                        <h5>Requestor Information (A-End)</h5>
                    </div>                      
                    <div className="textbox-gray">
                        <label htmlFor="companyName">Company Name</label>
                        <input type="text" placeholder={orderDetail.company_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="picName">PIC Name</label>
                        <input type="text" placeholder={orderDetail.pic_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="contactEmail">Contact e-mail</label>
                        <input type="text" placeholder={orderDetail.email_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="orderDate">Order Date</label>
                        <input type="text" placeholder={formatDate(orderDetail.order_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="comboBox" className='requestLocation'>Request Location</label>
                        <select id="comboBox" name="options" disabled>
                            <option value="option1">{orderDetail.order_location_name}</option>
                        </select>
                    </div>
                </div>

                <div className="destination-information">
                    <div className="title-box-order-input">
                        <h5>Destination Information (B-End)</h5>
                    </div>             
                    <div className="textbox-gray">
                        <label htmlFor="companyName">Company Name</label>
                        <input type="text" placeholder={orderDetail.company_destination} disabled />
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="picName">PIC Name</label>
                        <input type="text" placeholder={orderDetail.pic_destination} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="contactEmail">Contact e-mail</label>
                        <input type="text" placeholder={orderDetail.email_destination} disabled/>
                    </div>            
                </div>                
            </div>
              
         {/*  */}

         {orderDetail.orderItemlistByOrderId && orderDetail.orderItemlistByOrderId.length > 0 && orderDetail.orderItemlistByOrderId.map((order) => (
        //  {orderDetail.orderItemlist.map((order) => (
         <div className='box-two-part'>          
            <div className="a-end-information">
                <div className="title-box-order-input">
                    <h5>A-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.cable_type_a}</option>
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.interface_name_a}</option>
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.floor_name_a}</option>
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.room_name_a}</option>
                    </select>
                </div>   
                <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={order.a_end_rack_id} disabled/>
                </div>
                <div className="textbox-gray">
                        <label htmlFor="cableQuantity">Cable Quantity</label>
                        <input type="text" placeholder={order.cable_quantity} disabled/>
                </div>
            </div>

            <div className="b-end-information">
                <div className="title-box-order-input">
                    <h5>B-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.cable_type_b}</option>                 
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.interface_name_b}</option>
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.floor_name_b}</option>
                    </select>
                </div>
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{order.room_name_b}</option>                      
                    </select>  
                </div>               
                <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={order.b_end_rack_id} disabled/>
                </div>                 
            </div>    
        </div>
        ))}    

        <div className='box-two-part'>      
            <div className='approval-history'>
                <h5>Approval History</h5>
                <table class="table table-bordered">
                       <thead>
                            <tr>
                            <th scope="col">Date</th>
                            <th scope="col">User</th>
                            <th scope="col" className="note-column">Note</th>                           
                            </tr>
                        </thead>
                        <tbody>                     
                        {orderDetail.orderApprovalListByOrderId.map((order) => (
                            <tr>
                                <td>{formatDate(order.approval_date)}</td>
                                <td>{order.username}</td>
                                <td className="note-column">{order.notes}</td>
                            </tr>
                           ))}   
                        </tbody>
                    </table> 
                </div> 

                <div className='feedback-history'>
                <h5>Feedback History</h5>
                <table class="table table-bordered">
                       <thead>
                            <tr>
                            <th scope="col">Date</th>
                            <th scope="col">User</th>
                            <th scope="col" className="note-column">Note</th>                           
                            </tr>
                        </thead>
                        <tbody>
                        {orderDetail.orderFeedbackListByOrderId.map((order) => (
                            <tr>
                                <td>{formatDate(order.feedback_date)}</td>
                                <td>{order.username}</td>
                                <td className="note-column">{order.feedback}</td>
                            </tr>
                           ))}    
                        </tbody>
                    </table> 
                </div>               
            </div>

            <div className='box-two-part'>
                <form onSubmit={handleConfirmation}>
                    <div className="feedback-order">    
                        <div className="title-box-order-input">
                            <h5>Order Approval</h5>
                        </div>                        
                        <div className="textbox-gray">
                            <label htmlFor="currentDate">Date</label>
                            <input type="text" placeholder={getCurrenDate()} disabled/>
                        </div>
                        <div className="textbox-gray">
                            <label htmlFor="user">User</label>
                            <input type="text" placeholder={customerByToken.email} disabled/>
                        </div>
                        <div className="textbox">
                            <label htmlFor="Note">Note</label>
                            <textarea
                            value={notes} 
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder='Note'
                            required
                        ></textarea>  
                        </div>    
                        {error && <p className="error-message">{error}</p>}
                        <input type="submit" className="btn-submit-order-approval-one" value="Approve" 
                            onClick={() => setOrderStatusCode("XCPSTS-002")}/>
                        <input type="submit" className="btn-reject" value="Reject" 
                            onClick={() => setOrderStatusCode("XCPSTS-100")}/>               
                    </div>    
                </form>                 
            </div>                   
        </div>
    );
}

export default OrderApproval;
